import { bookingApiSlice } from '../api/booking/bookingApiSlice';
import Logger from '../common/logger';
import { store } from '../store/store';
import { CustomerMailRefusal, mailBlockedOf } from '../utils/customerMailGuard';
import { EditRoomRentalBookingPayload } from '../types/bookingCreation';

export const useEditRoomRentalBooking = (orderId: string) => {
    return async (
        roomRentalData: EditRoomRentalBookingPayload,
        saveMode: 'save_only' | 'save_and_send_email',
    ): Promise<{success: boolean, reason?: string, mailBlocked?: CustomerMailRefusal | null}> => {
        try {
            const response = await store.dispatch(
                bookingApiSlice.endpoints.editRoomRentalBooking.initiate(
                    {
                        orderId: orderId, 
                        data: roomRentalData,
                        saveMode: saveMode,
                    }),
            ).unwrap();
            // PO, 2026-10-30: saved, but the customer mail may have been refused.
            return {success: true, mailBlocked: mailBlockedOf(response)};
        } catch (error) {
            Logger('editRoomRentalBooking').error(error);
            // The server says why when the new slot is taken (`slot_taken`),
            // so the screen can explain it instead of asking for a retry.
            const reason = (error as { data?: { reason?: unknown } })?.data?.reason;
            return {success: false, reason: typeof reason === 'string' ? reason : undefined};
        }
    };
};

/** The message for a failed edit: a taken slot is explained, not retried. */
export const editFailureMessageKey = (reason?: string): string =>
    reason === 'slot_taken' ? 'edit_booking.response.slot_taken' : 'edit_booking.response.failure';
